import {
    clearUsernameSettings,
    tryLoadUsernameSettings,
    trySaveUsernameSettings,
} from "../../modules/login/loginStorage"

const APP_BASE_KEY = "gopay.menu.manager"

export enum StorageKey {
    USERNAME = "username",
    CONTROL_KITCHEN_MODE = "control-kitchen-mode",
    LAST_NEWS_CHECK = "last-news-check",
    MEETING_SERVICE_TIME_PERIOD = "meeting-service-time-period",
    TAKEAWAY_TIME_PERIOD = "takeaway-time-period",
    LUNCH_TIME_PERIOD = "lunch-time-period",
    USER_DASHBOARD_TIME_PERIOD = "user-dashboard-time-period",
    MERCHANT_PRODUCT_TOUR_V1 = "merchant-product-tour-v1",
    MERCHANT_PRODUCT_TOUR_FORCE_RUN = "merchant-product-tour-force-run",
    TAKEAWAY_ANNOUNCEMENT_TOUR_SEEN = "takeaway-announcement-tour-seen",
    SERVICE_CENTER_MEETING_SERVICE_FILTERS = "service-center-meeting-service-filters",
    SERVICE_CENTER_RESOURCE_BOOKING_FILTERS = "service-center-resource-booking-filters",
    SERVICE_CENTER_GUEST_CHECK_IN_PREFS = "service-center-guest-check-in-prefs",
    SERVICE_CENTER_MEETING_AUDIENCE_FILTER = "service-center-meeting-audience-filter",
    CREATE_ORDER_TIMELINE_LOCATIONS = "create-order-timeline-locations",
}

function getKey(key: StorageKey) {
    return `${APP_BASE_KEY}.${key}`
}

/**
 * Used to quick get and set value in the browsers local storage
 * @returns exposed methods, get and set
 */

const get = (key: StorageKey) => {
    return localStorage.getItem(getKey(key))
}

const set = (key: StorageKey, value: string) => {
    localStorage.setItem(getKey(key), value)
}
export const LocalCache = () => {
    const getUsernameSettings = () => tryLoadUsernameSettings(localStorage, getKey(StorageKey.USERNAME))
    const setUsernameSettings = (username: string) =>
        trySaveUsernameSettings(localStorage, getKey(StorageKey.USERNAME), username)
    const removeUsernameSettings = () => clearUsernameSettings(localStorage, getKey(StorageKey.USERNAME))

    return {
        getUsernameSettings,
        setUsernameSettings,
        removeUsernameSettings,
        get,
        set,
    }
}
